import { CardFooterActionsContainer, CardFooterContainer } from './styled';
export function CardFooter(props) {
    const { children, description } = props;
    return (<CardFooterContainer>
      {description}
      <CardFooterActionsContainer>{children}</CardFooterActionsContainer>
    </CardFooterContainer>);
}
